/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Diamond, LineChart, Users } from "lucide-react";
import { ref, get } from "firebase/database"; // Firebase Realtime Database
import { toast } from "react-toastify"; // For toast notifications
import { database } from "../../../firebase"; // Your Firebase configuration
import AppLoader from "../../AppLoader";

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const Card = ({ children, className }) => (
  <div className={`rounded-lg shadow-lg ${className}`}>{children}</div>
);

const DashboardContent = ({ user }) => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalScan, setTotalScan] = useState(0);
  // Function to fetch user data
  const fetchUserData = async (userId) => {
    try {
      const userRef = ref(database, "users/" + userId);
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userData = snapshot.val();
        fetchUsersData(userData.companyId);
        fetchTotalScanData(userData.companyId);
      } else {
        toast.error("user data not found.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Scan data:", error);
      setLoading(false);
    }
  };

  // Function to fetch users data
  const fetchUsersData = async (companyId) => {
    try {
      const usersRef = ref(database, "users");
      const snapshot = await get(usersRef);
      const users = snapshot.val();

      if (users) {
        const filteredUsers = Object.values(users).filter(
          (user) => user.companyId === companyId
        );

        const activeCount = filteredUsers.filter(
          (user) => user.isActive === true
        ).length;
        const inactiveCount = filteredUsers.filter(
          (user) => user.isActive === false
        ).length;

        setTotalUsers(activeCount + inactiveCount);

        setChartData([
          { name: "Active Users", value: activeCount, color: "#4caf50" },
          { name: "Inactive Users", value: inactiveCount, color: "#f44336" },
        ]);

        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
      toast.error("Error fetching users data.");
      setLoading(false);
    }
  };
  const fetchTotalScanData = async (companyId) => {
    if (!companyId) return;
  
    try {
      const companiesRef = ref(database, `/companies/${companyId}`);
      const companiesSnapshot = await get(companiesRef);
  
      if (!companiesSnapshot.exists()) {
        console.error("Company not found");
        return;
      }
  
      const company = companiesSnapshot.val();
      if (!company.companyName) {
        console.error("Company name is missing");
        return;
      }
  
      const visitsRef = ref(database, `/digitalCardVisits/${company.companyName}`);
      const snapshot = await get(visitsRef);
  
      if (snapshot.exists()) {
        console.log(snapshot.val());
        let totalVisits = Object.values(snapshot.val()).reduce((acc, user) => acc + (user.visitCount || 0), 0);
        console.log(`Total visits: ${totalVisits}`);
        setTotalScan(totalVisits)
      } else {
        console.log("No visit data found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  const barChartData = [
    { month: "JAN", CHN: 30, USA: 40, UK: 35 },
    { month: "FEB", CHN: 25, USA: 15, UK: 45 },
    { month: "MAR", CHN: 20, USA: 25, UK: 30 },
    { month: "APR", CHN: 35, USA: 30, UK: 20 },
    { month: "MAY", CHN: 30, USA: 35, UK: 45 },
    { month: "JUN", CHN: 25, USA: 40, UK: 30 },
    { month: "JUL", CHN: 20, USA: 30, UK: 35 },
    { month: "AUG", CHN: 25, USA: 35, UK: 40 },
  ];
  useEffect(() => {
    if (user) {
      fetchUserData(user.uid);
    }
  }, [user]);

  if (loading) {
    return <AppLoader />;
  }

  return (
    <main className="flex-1 p-6">
      <div className="grid gap-6 md:grid-cols-3">
        <Card className="bg-gradient-to-br from-pink-700 to-red-400 text-white">
          <div className="p-6">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Total User</h3>
              <LineChart className="h-5 w-5" />
            </div>
            <p className="mt-4 text-3xl font-bold">{totalUsers}</p>
            <p className="mt-2 text-sm"></p>
          </div>
        </Card>
        <Card className="bg-gradient-to-br from-red-400 to-blue-400 text-white">
          <div className="p-6">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Total Scan</h3>
              <Users className="h-5 w-5" />
            </div>
            <p className="mt-4 text-3xl font-bold">{totalScan}</p>
            <p className="mt-2 text-sm"></p>
          </div>
        </Card>
      </div>

      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <Card>
          <div className="p-6 bg-white">
            <h3 className="mb-4 text-lg font-medium">User Status</h3>
            <div className="h-full">
              <ResponsiveContainer width="100%" height={300}>
                {chartData.length > 0 ? (
                  <PieChart>
                    <Pie
                      data={chartData}
                      innerRadius={60}
                      outerRadius={80}
                      paddingAngle={5}
                      dataKey="value"
                    >
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                ) : (
                  <p>No data available for the pie chart.</p>
                )}
              </ResponsiveContainer>
              <div className="mt-4 grid grid-cols-2 gap-4 text-center">
                {chartData.map((item, index) => (
                  <div key={index}>
                    <div className="text-sm font-medium">{item.name}</div>
                    <div
                      className="text-2xl font-bold"
                      style={{ color: item.color }}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </main>
  );
};

export default DashboardContent;
